<template>
  <div></div>
</template>

<script>

/*!
* Survey.js v1.2.0
* (c) 2015-2017 Innowaytion
*/
(function(){'use strict';
var builtVersion="1.2.0";console.log("Using Survey Conduct "+builtVersion),window.DLOOP||(window.DLOOP={});var DLOOP=window.DLOOP;DLOOP.createSurvey=function(a,b,c){if(!a)return void console.error("Undefined container element");if(b||(b={}),c||(c={}),c.version||(c.version=builtVersion),"string"==typeof b)try{b=JSON.parse(b)}catch(a){return void console.error(a)}if(!_version.check(b))return _templates.loadUnsupported(a,_version.get(b)),void(c.onFail&&c.onFail("Unsupported Json version ("+_version.get(b)+")"));var d=_localize.init(c);if(b.questions&&0!==b.questions.length){for(var e=_themeEditingFactory.create(c),f=_playerFactory.create(e),g=_templates.loadQuestion(a,c,e,d,f,c.version),h=_themeFactory.create(b.resources,b.theme,g),i=[],j=0;j<b.questions.length;++j){var k=_questionsFactory.create(b.questions[j],h,f,e,b.resources,c);k&&i.push(k)}return!1!==c.autoStart&&f.start(i,g),{start:function(){return f.start(i,g)},next:function(){return f.loadNextQuestion()},previous:function(){return f.loadPreviousQuestion()},getResults:function(){return f.getResults()}}}if(c&&c.onFail){c.onFail("Empty survey: No questions found");var l=document.createElement("div");l.className="conduct empty-survey",d.string("NoQuestionsFound","The survey is empty",function(a){l.innerHTML=a}),a.innerHTML="",a.appendChild(l)}};var _questionsFactory=function(){var a={};return{register:function(b){var c=b();return c&&c.type&&c.create?a[c.type]?void console.error("Duplicate quesiton factory"):void(a[c.type]=c.create):void console.error("Invalid question factory")},create:function(b,c,d,e,f,g){if(!b)return void console.error("Invalid argument");var h=b.groupType?b.groupType:b.type;return a[h]?a[h](b,c,d,e,f,g):void console.error("Unsupported question type: "+h)}}}.call(),loadCss=function(a,b){for(var c=b?a.replace(/.*\//,""):a,d=document.getElementsByTagName("link"),e=0;e<d.length;++e){if((b?d[e].getAttribute("href").replace(/.*\//,""):d[e].getAttribute("href"))===c)return}var f=document.getElementsByTagName("head")[0],g=document.createElement("link");g.rel="stylesheet",g.type="text/css",g.href=a,f.appendChild(g)},loadScript=function(a,b){var c;if(!b)return void console.error("Undefined path for script");var d=document.createElement("script");return d.src=b,d.addEventListener("load",function(){c&&c()},!1),a.appendChild(d),{then:function(a){return c=a,loadScript}}},_localize=function(){var a={},b={},c=function(c,d){if(c&&(d&&(a[c]||(a[c]=[]),a[c].push(d)),a[c]&&b[c])){for(var e=0;e<a[c].length;++e)a[c][e]();a[c]=[]}};return{init:function(a){var d,e={string:function(a,e,f){f||console.error("Undefined callback"),c(d,function(){f(b[d]&&b[d][a]?b[d][a]:e||a)})},element:function(a){c(d,function(){if(b[d])for(var c=a.querySelectorAll("[rel^='localize:']"),e=0;e<c.length;++e){var f=c[e].getAttribute("rel").substr(9);b[d][f]&&(c[e].innerHTML=b[f])}})},changeLocale:function(e){if(e&&e!==d){if(d=e,b[e])return void c(d);var f;if(f=a&&a.localesPath?a.localesPath+"/local/"+e+".json":document.location.href.substr(0,document.location.href.lastIndexOf("/")+1)+"../survey/localization/"+e+".json",0===document.location.origin.indexOf("file://"))return void loadScript(document.body,f).then(function(){DLOOP.locales?(b[e]=DLOOP.locales,c(d)):console.error("Could not find the locales")});var g=new XMLHttpRequest;g.overrideMimeType("application/json"),g.onreadystatechange=function(){if(4===this.readyState){if(200===this.status)try{b[e]=JSON.parse(this.responseText)}catch(a){console.error(a)}else console.warn("Locale not found: "+e),b[e]={};c(d)}},g.open("GET",f,!0),g.send()}}};return e.changeLocale(a.locale?a.locale:navigator.language),e}}}.call(),_playerFactory=function(){return{create:function(a){var b,c,d=[],e=[],f=function(a){if(!(a>=d.length))return b=a,c.resetAnswerEl(),d[b].load(c),e.push(b),c.update(),b},g={start:function(a,b){if(d=a,e=[],c=b,d.length>0)return f(0);console.warn("No questions loaded")},canLoadPrevQuestion:function(){return e.length>1&&!a.isEditing()},canLoadNextQuestion:function(){if(a.isEditing())return!1;if(b>=d.length)return!1;if(!d[b].canLoadNextQuestion())return!1;var c=d[b].getNextQuestionIndex();return-1!==c&&(void 0===c?!(b+1>=d.length):null!==c)},canSubmit:function(){if(0===d.length||a.isEditing())return!1;for(var b=0;b<e.length;++b){var c=d[e[b]];if(c.getResponse()&&c.getResponse().response)return!0}return!1},isFirstQuestion:function(){return 0===b},isLastQuestion:function(){return d[b].getNextQuestionIndex()},loadPreviousQuestion:function(){if(g.canLoadPrevQuestion()){var a=e[e.length-2];return e.splice(e.length-2,2),f(a)}},loadNextQuestion:function(){if(g.canLoadNextQuestion()){var a=g.getNextQuestionIndex();return void 0===a?b+1>=d.length?void console.log("No more questions"):f(b+1):null!==a?f(a):void 0}},getResults:function(){for(var a=[],b=0;b<e.length;++b){var c=d[e[b]],f=c.getResponse();f&&a.push(f)}return a},getNextQuestionIndex:function(){if(b<d.length)return d[b].getNextQuestionIndex()},getCurrentQuestionIndex:function(){return b},getQuestionIndexFromId:function(a){if(void 0!==a){if("none"===a)return-1;for(var b in d)if(a===d[b].id)return parseInt(b);console.warn("Unable to find the index of the question: id = "+a)}}};return g}}}.call();_questionsFactory.register(function(){var a={Firstname:"firstName",Lastname:"lastName",Email:"email",Headline:"headline"},b=function(a,b,c,d,e){var f=document.createElement("li"),g=document.createElement("h2");g.innerHTML=a.label,"mandatory"===a.status&&(g.innerHTML+="<sup>*</sup>");var h=document.createElement("input");h.maxLength=100,h.value=a.value?a.value:"";var i=function(){a.value=h.value,d.updateTemplate()};return h.addEventListener("keyup",i),h.addEventListener("input",i),f.appendChild(g),f.appendChild(h),c.applyThemeToUnselectedAnswer(h),f};return{type:"contactQuestion",create:function(c,d,e,f,g,h){var i={},j=_createDefaultQuestion(i,c,e,d),k=h&&h.userInfo?h.userInfo:void 0;if(j)return c&&c.fields?i.fields=c.fields:i.fields=[],j.override("load",function(c){for(var e=document.createElement("ul"),f=0;f<i.fields.length;++f){var g=i.fields[f];g.label&&(!g.value&&a[g.label]&&k&&k[a[g.label]]&&(g.value=k[a[g.label]]),e.appendChild(b(g,0,d,j)))}return c.appendChild(e),c}),j.override("getResponse",function(a){var b={};k&&k.id&&(b.id=k.id);for(var c=0;c<i.fields.length;++c){var d=i.fields[c];if(d.value)b[d.label]=d.value;else if(d.isMandatory)return a}return a.response=b,a}),j.override("canLoadNextQuestion",function(){if(!0!==i.answerRequired)return!0;for(var a=0;a<i.fields.length;++a){var b=i.fields[a];if("mandatory"===b.status&&(!b.value||""===b.value))return!1}return!0}),i}}}),_questionsFactory.register(function(){function a(a){if(a){var b=/(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;return a.replace(b,function(a){return'<a href="'+a+'" target="_blank">'+a+"</a>"})}}return{type:"infoQuestion",create:function(b,c,d,e,f,g){var h={},i=_createDefaultQuestion(h,b,d,c);if(i)return i.renderQuestionText=function(a){a.setTitle()},i.override("load",function(b){var c=document.createElement("p");return c.className="title",h.text&&(c.innerHTML=a(h.text.replace(/\n/g,"<br/>"))),b.appendChild(c),b}),i.override("getResponse",function(a){return a.response="",a}),h}}}),_questionsFactory.register(function(){var a=function(a,b,c,d,e,f){if(void 0!==a.image||void 0!==a.text){var g=document.createElement("li");if(a.selected&&(g.className+=" selected"),void 0!==a.image&&f&&f.images){var h=document.createElement("img");h.src=f.images[a.image],g.appendChild(h)}if(a.text){var i=document.createElement("span");i.innerHTML=a.text,g.appendChild(i)}return e.isEditing()||g.addEventListener("click",function(){if(b.allowMultiSelection)a.selected?g.className=g.className.replace(/selected/g,""):g.className+=" selected",a.selected=!a.selected;else{var c,e=a.selected;for(c=0;c<b.answers.length;++c)b.answers[c].selected=!1;var f=g.parentNode.querySelectorAll("li");for(c=0;c<f.length;++c)f[c].className=f[c].className.replace(/selected/g,"");e||(a.selected=!0,g.className+=" selected")}d.updateTemplate()},!1),c.applyThemeToUnselectedAnswer(g),c.applyThemeToSelectedAnswer(g),e.registerEditableItem("answers",g),g}};return{type:"multiChoiceQuestion",create:function(b,c,d,e,f,g){var h={},i=_createDefaultQuestion(h,b,d,c);if(i)return h.allowMultiSelection=b.allowMultiSelection,h.isRightAnswersExist=b.isRightAnswersExist,h.answers=b.answers?JSON.parse(JSON.stringify(b.answers)):[],i.override("load",function(b){var d=document.createElement("ul"),g=h.answers;if(h.isRightAnswersExist)for(var j=0;j<h.answers.length;++j){var k=Math.floor(Math.random()*h.answers.length),l=Math.floor(Math.random()*h.answers.length);if(k!==l){var m=g[k];g[k]=g[l],g[l]=m}}for(var n in g){var o=a(g[n],h,c,i,e,f);o&&d.appendChild(o)}b.appendChild(d)}),i.override("getResponse",function(a){var b=[];for(var c in h.answers)h.answers[c].selected&&b.push(h.answers[c].id);if(b.length>0)return a.response=b,a}),i.override("canLoadNextQuestion",function(){if(!0!==h.answerRequired)return!0;for(var a in h.answers)if(h.answers[a].selected)return!0;return!1}),i.override("getNextQuestionIndex",function(a){if(!h.allowMultiSelection)for(var b in h.answers){var c=h.answers[b];if(c.selected){if(c.nextQuestionId){var e=d.getQuestionIndexFromId(c.nextQuestionId);if(void 0!==e)return e}break}}return a}),h}}}),_questionsFactory.register(function(){return{type:"openQuestion",create:function(a,b,c,d,e,f){var g={},h=_createDefaultQuestion(g,a,c,b);if(h)return g.maxLength=a.maxLength,h.override("load",function(a){var c,d=document.createElement("div"),e=document.createElement("textarea"),f=function(){c&&(c.innerHTML="Maximum characters: "+e.value.length+"/"+g.maxLength,e.value.length>=g.maxLength?c.style.color="red":c.style.color="inherit",e.value.length>0?g.response=e.value:g.response=void 0,h.updateTemplate())};e.placeholder="Type your answer here",g.response&&(e.innerHTML=g.response),g.maxLength||(g.maxLength=500),e.setAttribute("maxlength",g.maxLength),e.addEventListener("keyup",f,!1),e.addEventListener("input",f,!1),d.appendChild(e);var i=document.createElement("div");i.className="footer",c=document.createElement("div"),i.appendChild(c),f(),d.appendChild(i),b.applyThemeToUnselectedAnswer(e),a.appendChild(d)}),h.override("getResponse",function(a){if(g.response&&""!==g.response)return a.response=g.response,a}),h.override("canLoadNextQuestion",function(){return!0!==g.answerRequired||void 0!==g.response&&""!==g.response}),g}}});var _createDefaultQuestion=function(a,b,c,d){if(!a||!b)return void console.error("Invalid arguments");if(!b.id||!b.type)return void console.error("Invalid question. Missing id or type");var e;a.type=b.type,a.id=b.id,a.text=b.text?b.text:void 0,a.groupType=b.groupType?b.groupType:void 0,a.placeHolderTitle="Question",a.answerRequired=b.answerRequired,a.answerRequiredToSubmit=!1!==b.answerRequiredToSubmit,a.nextQuestionId=b.nextQuestionId,a.theme=b.theme,a.load=function(b){e=b,d.load(a.theme),f.renderQuestionText(e);var c=e.getAnswerEl();return c.className=a.groupType,c},a.getResponse=function(){return{questionId:a.id,response:void 0}},a.canLoadNextQuestion=function(){return!0},a.getNextQuestionIndex=function(){if(a.hasOwnProperty("nextQuestionId"))return c.getQuestionIndexFromId(a.nextQuestionId)};var f={override:function(b,c){if(c){var d=a[b];a[b]=function(){return c(d?d.apply(this,arguments):void 0)}}else console.error("Undefined function to override")},renderQuestionText:function(b){if(!a.text)return void b.setTitle();var c=a.text.replace(/\n/g,"<br/>");a.answerRequired&&(c+="<sup>*</sup>"),b.setTitle(c)},updateTemplate:function(){e&&e.update()}};return f};_questionsFactory.register(function(){var a=function(a,b){for(var c=0;c<a.answers.length;++c)if(a.answers[c].id===b.id)return c;return-1},b=function(b,c,d,e,f){if(void 0!==b.image||void 0!==b.text){var g=document.createElement("li");if(g.setAttribute("draggable",!0),void 0!==b.image&&f&&f.images){var h=document.createElement("img");h.src=f.images[b.image],g.appendChild(h)}if(b.text){var i=document.createElement("span");i.innerHTML=b.text,g.appendChild(i)}var j=document.createElement("button");j.innerHTML="&#8593";var k=document.createElement("button");return k.innerHTML="&#8595;",j.addEventListener("click",function(){if(!d.isEditing){var e=a(c,b);if(!(e<1)){c.answers.splice(e,1),c.answers.splice(e-1,0,b);var f=g.previousSibling;f&&g.parentNode.insertBefore(g,f)}}}),k.addEventListener("click",function(){if(!d.isEditing){var e=a(c,b);if(!(e>c.answers.length-2)){c.answers.splice(e,1),c.answers.splice(e+1,0,b);var f=g.nextSibling;f&&g.parentNode.insertBefore(g,f.nextSibling)}}}),g.appendChild(j),g.appendChild(k),g.addEventListener("dragstart",function(a){c.answerDragged=b},!1),d.applyThemeToUnselectedAnswer(g),e.registerEditableItem("answers",g),g}};return{type:"sortQuestion",create:function(a,c,d,e,f,g){var h={},i=_createDefaultQuestion(h,a,d,c);if(i)return h.largestLabel=a.largestLabel,h.smallestLabel=a.smallestLabel,h.answers=a.answers?JSON.parse(JSON.stringify(a.answers)):[],i.override("load",function(a){var d=document.createElement("div");if(h.largestLabel){var g=document.createElement("h2");g.innerHTML=h.largestLabel,d.appendChild(g)}var i=document.createElement("ul");for(var j in h.answers){var k=b(h.answers[j],h,c,e,f);k&&i.appendChild(k)}if(i.addEventListener("dragover",function(a){console.log("drag over")},!1),i.addEventListener("drop",function(a){console.log("drop")},!1),d.appendChild(i),h.smallestLabel){var l=document.createElement("h2");l.innerHTML=h.smallestLabel,d.appendChild(l)}return a.appendChild(d),a}),i.override("getResponse",function(a){var b=[];for(var c in h.answers)b.push(h.answers[c].id);return a.response=b,a}),h}}}),console.log("Using Survey Conduct "+builtVersion),window.DLOOP||(window.DLOOP={});var DLOOP=window.DLOOP;DLOOP.createSurvey=function(a,b,c){if(!a)return void console.error("Undefined container element");if(b||(b={}),c||(c={}),c.version||(c.version=builtVersion),"string"==typeof b)try{b=JSON.parse(b)}catch(a){return void console.error(a)}if(!_version.check(b))return _templates.loadUnsupported(a,_version.get(b)),void(c.onFail&&c.onFail("Unsupported Json version ("+_version.get(b)+")"));var d=_localize.init(c);if(b.questions&&0!==b.questions.length){for(var e=_themeEditingFactory.create(c),f=_playerFactory.create(e),g=_templates.loadQuestion(a,c,e,d,f,c.version),h=_themeFactory.create(b.resources,b.theme,g),i=[],j=0;j<b.questions.length;++j){var k=_questionsFactory.create(b.questions[j],h,f,e,b.resources,c);k&&i.push(k)}return!1!==c.autoStart&&f.start(i,g),{start:function(){return f.start(i,g)},next:function(){return f.loadNextQuestion()},previous:function(){return f.loadPreviousQuestion()},getResults:function(){return f.getResults()}}}if(c&&c.onFail){c.onFail("Empty survey: No questions found");var l=document.createElement("div");l.className="conduct empty-survey",d.string("NoQuestionsFound","The survey is empty",function(a){l.innerHTML=a}),a.innerHTML="",a.appendChild(l)}};var _templates=function(){return{loadUnsupported:function(a,b){var c=document.createElement("div");c.className="conduct";var d=document.createElement("div");d.className="unsupported",d.innerHTML="This version of the survey is not supported (v"+b+")",c.appendChild(d),a.innerHTML="",a.appendChild(c)},loadQuestion:function(a,b,c,d,e,f){b&&b.cssPath?loadCss(b.cssPath,!0):document.location.origin.indexOf("http://localhost")>=0?loadCss(document.location.origin+"/dist/"+f+"/survey/survey-"+f+".css",!0):loadCss(document.location.origin+"/survey-"+f+".css",!0);var g=document.createElement("div");g.className="conduct"+(c.isEditing()?" theme-editing":"");var h=document.createElement("content");h.className="content",g.appendChild(h);var i=document.createElement("header");i.appendChild(document.createElement("div")),c.registerDnDListenerOnEditableItem("header",i),h.appendChild(i);var j=document.createElement("main"),k=document.createElement("div");c.registerDnDListenerOnEditableItem("body",k);var l=document.createElement("div");l.className="title";var m=document.createElement("h2");l.appendChild(m),k.appendChild(l);var n=document.createElement("div");n.className="answers";var o=document.createElement("div");if(n.appendChild(o),k.appendChild(n),b&&b.showControls){var p=document.createElement("div");p.className="controls";var q=document.createElement("button");q.className="btn-large btn-primary btn-controls",d.string("BT_PREVIOUS","Previous",function(a){q.innerHTML=a}),q.addEventListener("click",function(){e.loadPreviousQuestion()}),c.registerEditableItem("controls",q),p.appendChild(q);var r=document.createElement("button");r.className="btn-large btn-primary btn-controls",d.string("BT_NEXT","Next",function(a){r.innerHTML=a}),r.addEventListener("click",function(){e.loadNextQuestion()}),c.registerEditableItem("controls",r),p.appendChild(r);var s=document.createElement("button");s.className="btn-large btn-primary btn-controls",d.string("BT_SUBMIT","Submit",function(a){s.innerHTML=a}),s.addEventListener("click",function(){b&&b.onSubmit&&b.onSubmit(e.getResults())}),c.registerEditableItem("controls",s),p.appendChild(s),k.appendChild(p)}j.appendChild(k),h.appendChild(j);var t=document.createElement("footer");if(t.appendChild(document.createElement("div")),c.registerDnDListenerOnEditableItem("footer",t),h.appendChild(t),c.isEditing()){var u=document.createElement("canvas");u.className="overlay-theme-editing";var v=u.getContext("2d");h.appendChild(u),c.registerCanvasUpdate(function(a){a?(u.width=h.offsetWidth,u.height=h.offsetHeight,a(v,INNOWAYTION.utils.ui.offsetPosition(h)),u.style.display="block"):u.style.display="none"})}return a.innerHTML="",a.appendChild(g),{setTitle:function(a){m.innerHTML=a,m.style.display=a?"block":"none"},showHeaderWithRuler:function(a){a("display: table-row")},showFooterWithRuler:function(a){a("display: table-row")},getRootEl:function(){return h},getAnswerEl:function(){return o},resetAnswerEl:function(){o.innerHTML=""},update:function(){if(q&&r&&s){if(c.isEditing())return q.removeAttribute("disabled"),r.removeAttribute("disabled"),void s.removeAttribute("disabled");e.canLoadPrevQuestion()?q.removeAttribute("disabled"):q.setAttribute("disabled","disabled"),e.canLoadNextQuestion()?r.removeAttribute("disabled"):r.setAttribute("disabled","disabled"),e.canSubmit()?s.removeAttribute("disabled"):s.setAttribute("disabled","disabled")}}}}}}.call(),_themeEditingFactory=function(){var a=function(a,b,c,d){if(!c||!a||!b||0===b.length)return void console.error("Invalid arguments");var e;return c(function(a,c){a.clearRect(0,0,c.width,c.height),a.moveTo(0,0),a.lineTo(c.width,0),a.lineTo(c.width,c.height),a.lineTo(0,c.height),a.lineTo(0,0),a.closePath();var d,f=[];for(d=0;d<b.length;++d){var g=INNOWAYTION.utils.ui.offsetPosition(b[d]);g.top-=c.top,g.left-=c.left,a.moveTo(g.left,g.top),a.lineTo(g.left,g.top+g.height),a.lineTo(g.left+g.width,g.top+g.height),a.lineTo(g.left+g.width,g.top),a.lineTo(g.left,g.top),a.closePath(),f.push([g.left,g.top,g.width,g.height])}for(a.fillStyle="rgba(0, 0, 0, 0.5)",a.fill(),d=0;d<f.length;++d)a.beginPath(),a.lineWidth="3",a.strokeStyle="red",a.rect(f[d][0],f[d][1],f[d][2],f[d][3]),a.stroke();e={el:a.canvas,rect:c}}),e},b=function(a){a?a():console.error("Invalid argument")},c=function(c,d,f,g,h,i){if(!c||!g[f])return void console.error("Invalid arguments");var j=a(f,g[f].els,i);h&&h.stopPropagation(),d&&d.onItemHighlighted&&d.onItemHighlighted(f);var k=function(a){e(c,j.rect.left+a.offsetX,j.rect.top+a.offsetY,g)&&j.dismiss()};return j.click=function(a){if(d&&d.onItemClicked){var b;c.className.indexOf("selected")>=0&&(b="selected"),d.onItemClicked(f,c,b)}},j.dismiss=function(){j.el.removeEventListener("mouseover",k),j.el.removeEventListener("mousemove",k),j.el.removeEventListener("mouseleave",j.dismiss),j.el.removeEventListener("click",j.click),b(i)},j.el.addEventListener("mouseover",k,!1),j.el.addEventListener("mousemove",k,!1),j.el.addEventListener("mouseleave",j.dismiss,!1),j.el.addEventListener("click",j.click,!1),j},d=function(a,b,d,f,g,h){if(!a||!g)return void console.error("Invalid arguments");g.preventDefault&&g.preventDefault(),g.dataTransfer.dropEffect="move";var i=c(a,b,d,f,g,h),j=function(b){e(a,i.rect.left+b.offsetX,i.rect.top+b.offsetY,f,function(a){return!a.acceptDnDImage})?k():(b.preventDefault&&b.preventDefault(),b.stopPropagation(),b.dataTransfer.dropEffect="move")},k=function(){i.el.removeEventListener("dragover",j),i.el.removeEventListener("dragleave",k),i.el.removeEventListener("drop",l),i.dismiss()},l=function(a){k(),a.preventDefault&&a.preventDefault(),a.stopPropagation();var c=a.dataTransfer,e=c.files;if(0!==e.length){var f=new FileReader;f.onloadend=function(){(b||b.onDropImage)&&setTimeout(function(){b.onDropImage(d,this.result)}.bind(this),1)},f.readAsDataURL(e[0])}};i.el.addEventListener("dragover",j,!1),i.el.addEventListener("dragleave",k,!1),i.el.addEventListener("drop",l,!1)},e=function(a,b,c,d,e){for(var f=[],g=Object.keys(d),h=0;h<g.length;++h)for(var i=d[g[h]].els,j=0;j<i.length;++j)if(!e||!e(i[j])){var k=INNOWAYTION.utils.ui.offsetPosition(i[j]);if(k.left<=b&&k.left+k.width>=b&&k.top<=c&&k.top+k.height>=c){f.push({el:i[j],area:k.width*k.height});break}}return f.sort(function(a,b){return a.area>b.area}),f.length>0&&a!==f[0].el};return{create:function(e){var f,g,h={};e&&e.themeEditing&&(f=e.themeEditing(function(c){c?h[c]&&a(c,h[c].els,g):b(g)},function(a){if(h[a])return h[a].maxSize}));var i={isEditing:function(){return e&&e.themeEditing},registerCanvasUpdate:function(a){g=a},registerEditableItem:function(a,b,d){return!!i.isEditing()&&(b&&a?(h[a]?h[a].els.push(b):h[a]={els:[b]},d&&(h[a].maxSize=d),b.addEventListener("mouseover",function(d){c(b,f,a,h,d,g)}),!0):(console.error("Invalid parameters"),!1))},registerDnDListenerOnEditableItem:function(a,b,c){i.registerEditableItem(a,b,c)&&(f&&f.onDropImage||console.warn('No callbacks registered for "onDropImage". Probably nothing will be saved'),b.acceptDnDImage=!0,b.addEventListener("dragover",function(c){d(b,f,a,h,c,g)}))}};return i}}}.call(),_themeFactory=function(){var a=0,b=function(){return"theme_"+ ++a},c=function(a,c,d,e,f,g,h){if(!f)return void console.error("Invalid argument");if(e){var i=b();f.className+=" "+i;var j=[c+" "+f.nodeName+"."+i+(g||"")];a.all.createSelectorRules(j,e.all,void 0,d),h.push({selectors:j,theme:e})}},d=function(a,b,c,d,e){if(b&&b.length){var f=function(c,f){for(var g=!1,i=b[0]+f,j=1;j<b.length;++j)i+=","+b[j]+f;i+="{";var k=function(a){i+=a+";",g=!0};h(c,k,e),g&&(d&&d(k),i+="}",a.insertRule(i,0))};f(c,""),c["font-family"]&&f({"font-family":c["font-family"]}," *")}},e=function(a){return a?a.offsetWidth<=300?"portrait":a.offsetHeight<=300?"landscape":"all":"all"},f=function(a){a&&(a.remove?a.remove(a):a.removeNode(!0))},g=function(a){var b=document.createElement("style");return b.appendChild(document.createTextNode("")),document.head.appendChild(b),{createSelectorRules:function(a,c,e,f){if(!a)return void console.error("Invalid arguments");c&&d(b.sheet,a,c,e,f)},destroy:function(){f(b)}}},h=function(a,b,c){if(b&&a){if(void 0!==a.backgroundImage)switch(c&&b("background-image: url('"+c[a.backgroundImage]+"')"),a.backgroundMode){case"stretched":b("background-repeat: no-repeat"),b("background-size: 100% 100%"),b("background-position: center");break;case"fitToWidth":b("background-repeat: no-repeat"),b("background-size: cover"),b("background-position: center");break;case"left":b("background-repeat: no-repeat"),b("background-position: left center"),b("background-size: contain");break;case"right":b("background-repeat: no-repeat"),b("background-position: right center"),b("background-size: contain");break;default:void 0!==a.backgroundMode&&"center"!==a.backgroundMode&&console.log("Unsupported mode for background mode: "+a.backgroundMode),b("background-repeat: no-repeat"),b("background-position: center"),b("background-size: contain")}a.backgroundColor&&b("background-color: "+a.backgroundColor),a.color&&b("color: "+a.color),a["font-family"]&&b("font-family: "+a["font-family"])}},i=function(a,b,c,d){if(c){var f=function(e,f){var h=g(b.getRootEl()),i={},j={};if(c.body&&c.body[e]&&(i[e]={},j[e]={},i[e].backgroundColor=c.body[e].backgroundColor,i[e].backgroundImage=c.body[e].backgroundImage,j[e].color=c.body[e].color),h.createSelectorRules([a+" main"],i[e],void 0,d),h.createSelectorRules([a+" .title"],j[e],void 0,d),h.createSelectorRules([a],c.text?c.text[e]:void 0,void 0,d),h.createSelectorRules([a+" footer"],c.footer?c.footer[e]:void 0,b.showFooterWithRuler,d),h.createSelectorRules([a+" header"],c.header?c.header[e]:void 0,b.showHeaderWithRuler,d),h.createSelectorRules([a+" .controls button[disabled='']"],c.controls?c.controls[e]:void 0,void 0,d),f)for(var k=0;k<f.length;++k)h.createSelectorRules(f[k].selectors,f[k].theme[e],void 0,d);return h},h=[],i="all",j={};j.all=f("all");var k=function(){l&&(clearInterval(l),l=void 0);for(var a=Object.keys(j),b=0;b<a.length;++b)j[a[b]]&&j[a[b]].destroy();h=void 0},l=setInterval(function(){if(0===b.getRootEl().offsetWidth)return k(),void console.log("Theme was destroyed (Root element is likely to have disappeared)");var a=e(b.getRootEl());"all"!==i&&a!==i&&(j[i].destroy(),j[i]=null),"all"!==a&&a!==i&&(j[a]=f(a,h)),i=a},100);return{styleSheets:j,theme:c,destroy:k,styleForEls:h}}};return{create:function(a,d,e){var f,g;a&&(f=a.themes,g=a.images);var h=b(),j=".conduct .content."+h;e.getRootEl().className+=" "+h;var k;return{applyThemeToUnselectedAnswer:function(a){k&&k.theme&&k.theme.answers&&c(k.styleSheets,j,g,k.theme.answers.unselected,a,":not(.selected)",k.styleForEls)},applyThemeToSelectedAnswer:function(a){k&&k.theme&&k.theme.answers&&c(k.styleSheets,j,g,k.theme.answers.selected,a,".selected",k.styleForEls)},load:function(a){k&&k.destroy(),k="object"==typeof a?i(j,e,a,g):f?i(j,e,f[void 0===a?d:a],g):void 0}}}}}.call(),_version=function(){var a=["1.1.0","1.2.0"];return{get:function(a){return"version"in a?a.version:"0.0.0"},check:function(b){var c=_version.get(b);return!!c&&a.indexOf(c)>=0}}}.call();
//# sourceMappingURL=survey-1.2.0.js.map
})();

export default {
  props: {
    survey: Object,
    cssPath: String,
    localizationPath: String,
    user: Object,
    onSubmit: Function,
    onFail: Function
  },

  mounted() {
    this.reload(this.survey);
  },

  watch: {
    survey(newSurvey) {
      this.reload(newSurvey);
    }
  },

  methods: {
    reload(json) {
      if (!json) {
        return;
      }

      DLOOP.createSurvey(this.$el, json, {
        cssPath: this.cssPath,
        localesPath: this.localizationPath,
        showControls: true,
        onFail: (err) => {
            if (this.onFail) {
              this.onFail(err);
            } else {
              console.log('Failed to load the survey: ' + err);
            }
        },
        onSubmit: this.onSubmit,
        userInfo: this.user
    });
    }
  }
}

</script>


<style>

.btn-primary {
  color: #fff;
  background-color: #d4451d;
  text-transform: capitalize;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none; }

.btn-primary:hover {
  background-color: #bf3915;
  cursor: pointer; }

.btn-row {
  text-align: center;
  padding: 0 8px;
  height: 100%;
  font-size: 8px;
  transition: all 0.2s;
  text-transform: capitalize;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none; }
  .btn-row > div {
    position: relative;
    top: 50%;
    transform: translateY(-50%); }

.btn-with-icon {
  white-space: nowrap;
  font-size: 12px;
  text-transform: capitalize;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none; }
  .btn-with-icon > div:first-child {
    margin-right: 5px; }
  .btn-with-icon > div {
    display: inline-block; }

.btn-primary[disabled],
.btn-primary[disabled]:hover {
  background-color: #aaa;
  cursor: initial; }

.btn-small {
  font-size: 8px;
  padding: 0.2rem 0.5rem; }

.btn-large {
  font-size: 0.9em;
  padding: 0.4rem 1rem;
  font-weight: 600; }

.btn-dual-color {
  overflow: hidden;
  width: 30px;
  height: 20px;
  border: 1px solid #f1f2f2;
  position: relative;
  background-color: white; }
  .btn-dual-color div {
    transform: skewX(-45deg);
    height: 100%;
    width: 100%;
    position: absolute; }
  .btn-dual-color div:first-child {
    left: -50%; }
  .btn-dual-color div:last-child {
    left: 50%; }

.conduct .btn-delete-list-item,
.create .btn-delete-list-item {
  height: 100%; }
  .conduct .btn-delete-list-item > button,
  .create .btn-delete-list-item > button {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    margin: 0 4px; }

.create .btn-delete {
  color: white;
  padding: 6px 8px;
  font-size: 10px;
  border-radius: 50%;
  text-align: center;
  background-color: #d4451d; }

.list-horz {
  display: table;
  width: 100%; }
  .list-horz > .left, .list-horz > .middle, .list-horz > .right {
    display: table-cell;
    height: 100%;
    width: 1px;
    vertical-align: top; }
  .list-horz > .middle {
    width: 100%; }
  .list-horz > .right .btn-delete-list-item {
    display: none; }

.list-items > li:hover .list-horz > .right .btn-delete-list-item,
.list-items > li.selected .list-horz > .right .btn-delete-list-item {
  display: block; }

.list-items > li:hover .list-horz > .right .btn-delete-list-item:hover,
.list-items > li.selected .list-horz > .right .btn-delete-list-item:hover {
  cursor: pointer; }

.list-vert {
  display: table;
  height: 100%; }
  .list-vert > .top, .list-vert > .middle, .list-vert > .bottom {
    display: table-row;
    height: 1px;
    width: 100%;
    vertical-align: top; }
  .list-vert > .middle {
    height: 100%; }

.create * {
  font-family: sans-serif;
  /* 1 */ }

.conduct *,
.create * {
  box-sizing: border-box;
  -ms-text-size-adjust: 100%;
  /* 2 */
  -webkit-text-size-adjust: 100%;
  /* 2 */ }
.conduct h3,
.create h3 {
  font-size: 0.8em;
  font-weight: normal; }
.conduct h4,
.create h4 {
  font-size: 10px;
  font-weight: normal;
  margin: 0;
  padding: 0; }
.conduct ul,
.create ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  width: initial;
  height: initial;
  border: initial; }
.conduct li,
.create li {
  margin: 0;
  transition: .2s ease-out;
  width: initial;
  height: initial;
  border-bottom: initial;
  color: initial; }
.conduct button,
.create button {
  font-weight: 100;
  cursor: pointer;
  outline: 0;
  border: none;
  border-radius: 0;
  text-align: center;
  text-transform: none;
  letter-spacing: .5px;
  transition: .2s ease-out;
  user-select: none;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  vertical-align: middle;
  -webkit-tap-highlight-color: transparent;
  text-decoration: none;
  color: #fff;
  background-color: #d4451d; }
.conduct button:hover,
.create button:hover {
  background-color: #bf3915;
  transition: .2s ease-out; }
.conduct p,
.create p {
  margin: 0; }
.conduct textarea,
.create textarea {
  resize: none;
  outline: none; }

.conduct .multiChoiceQuestion,
.conduct .sortQuestion {
  font-size: 1em; }
  .conduct .multiChoiceQuestion li,
  .conduct .sortQuestion li {
    padding: 10px;
    margin: 5px 0;
    background-color: #f1f2f2; }
    .conduct .multiChoiceQuestion li span,
    .conduct .sortQuestion li span {
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      vertical-align: top; }
  .conduct .multiChoiceQuestion li:hover,
  .conduct .sortQuestion li:hover {
    background-color: #cdd1d8; }
  .conduct .multiChoiceQuestion .selected:hover,
  .conduct .multiChoiceQuestion .selected,
  .conduct .sortQuestion .selected:hover,
  .conduct .sortQuestion .selected {
    background-color: #a7a9ac; }
  .conduct .multiChoiceQuestion img,
  .conduct .sortQuestion img {
    max-height: 60px;
    max-width: 200px;
    margin-right: 10px; }
  .conduct .multiChoiceQuestion .checkmark-for-image,
  .conduct .sortQuestion .checkmark-for-image {
    margin-top: 1.6em; }
  .conduct .multiChoiceQuestion .icon,
  .conduct .sortQuestion .icon {
    width: 18px;
    height: 18px; }

.conduct.theme-editing .multiChoiceQuestion li:hover,
.conduct .sortQuestion li:hover {
  background-color: #f1f2f2; }
.conduct.theme-editing .multiChoiceQuestion .selected:hover,
.conduct .sortQuestion .selected:hover {
  background-color: #a7a9ac; }

.conduct .sortQuestion button {
  padding: 0;
  width: 20px;
  height: 20px;
  border-radius: 10px;
  margin-left: 5px;
  float: right; }
.conduct .sortQuestion h2:first-child {
  margin: 0 10px 10px 0; }
.conduct .sortQuestion h2:last-child {
  margin: 10px 10px 0 0; }
.conduct .sortQuestion h2 {
  font-size: 12px;
  font-weight: normal;
  text-align: right;
  color: #aaa; }

.conduct .contactQuestion {
  font-size: 0.9em; }
  .conduct .contactQuestion h2 {
    font-size: 0.8em;
    margin: 0.7em 0 0.2em 0;
    user-select: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    color: #888;
    font-weight: 500; }
  .conduct .contactQuestion sup {
    color: red; }
  .conduct .contactQuestion ul {
    margin: 10px 0 0 0;
    height: 95%;
    padding-right: 4px;
    overflow-x: hidden;
    overflow-y: auto; }
  .conduct .contactQuestion input {
    width: 100%;
    padding: 2px 5px;
    font-size: 14px;
    border: 1px solid #eee; }
  .conduct .contactQuestion input:focus {
    outline: none;
    border: 1px solid #f1f2f2; }

.conduct .openQuestion > div {
  display: table;
  width: 100%;
  height: 100%; }
.conduct .openQuestion textarea,
.conduct .openQuestion .footer {
  display: table-row;
  height: 1px; }
.conduct .openQuestion textarea {
  height: 100%;
  width: 100%;
  margin: 1px;
  font-size: 1em;
  white-space: pre-wrap;
  overflow-y: auto;
  padding: 5px; }
.conduct .openQuestion .footer {
  width: 100%;
  text-align: right;
  font-size: 0.9em; }
  .conduct .openQuestion .footer > div {
    padding: 4px 10px 5px 0; }

.conduct .infoQuestion p.title {
  font-size: 12px;
  padding: 10px;
  text-align: center;
  display: block;
  width: 100%;
  height: 100%; }

.conduct {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative; }

.conduct.empty-survey {
  text-align: center;
  width: 100%;
  padding: 40px 20px 0 20px; }

.conduct .unsupported {
  text-align: center;
  font-size: 12px;
  padding: 20px 10px 10px 10px; }

.conduct .content {
  font-family: Verdana;
  display: table;
  width: 100%;
  height: 100%; }
  .conduct .content header,
  .conduct .content footer {
    display: none;
    height: 1px; }
    .conduct .content header > div,
    .conduct .content footer > div {
      min-height: 40px;
      max-height: 80px; }
  .conduct .content main {
    display: table-row;
    height: 100%; }
    .conduct .content main > div {
      display: table;
      height: 100%;
      width: 100%; }
  .conduct .content .title,
  .conduct .content .answers,
  .conduct .content .controls {
    display: table-row;
    height: 1px; }
  .conduct .content .title h2 {
    font-size: 18px;
    margin: 5px 15px 20px 15px;
    font-weight: 500; }
  .conduct .content .title sup {
    color: red; }
  .conduct .content .answers {
    height: 100%; }
    .conduct .content .answers > div {
      padding: 0 10px;
      overflow: auto;
      height: 100%; }
  .conduct .content .controls {
    text-align: right; }
    .conduct .content .controls button {
      margin: 10px 10px 8px 0; }
    .conduct .content .controls button[disabled] {
      background-color: #aaa; }
  .conduct .content .highlight-overlay {
    position: absolute;
    display: none;
    top: 0;
    left: 0; }

.conduct.theme-editing {
  /*position: relative;

  .customizable-header,
  .customizable-footer {
    display: block;
  }

  .footer {
    img {
      min-width: 29px;
      min-height: 29px;
      display: block;
    }
  }

  #highlightOverlayLeft {
    left: 0;
  }

  #highlightOverlayRight {
    right: 0;
  }

  #highlightOverlayTop {
    top: 0;
    left: 0;
    width: 100%;
  }

  #highlightOverlayBottom {
    bottom: 0;
    left: 0;
    width: 100%;
  }

  .btn-controls {
    display: inline-block;
  }*/ }
  .conduct.theme-editing header,
  .conduct.theme-editing footer {
    display: table-row; }
  .conduct.theme-editing .overlay-theme-editing {
    width: 100%;
    height: 100%;
    display: none;
    position: absolute;
    top: 0;
    left: 0; }

/*# sourceMappingURL=survey-1.2.0.css.map */


</style>



// WEBPACK FOOTER //
// survey-1.2.0.vue?58d6081a